// import _ from "../Trans";
// import ReactGA from "react-ga4";
// import {fetchUserUrl, GA_CODE, logoutPage, toastConfig, updatePasswordUrl} from "../Config";
import {Col, Container, Row} from "reactstrap";
import {getTrophies} from "./ApiCalls";
import Config from "../Config";
import React, {useEffect, useState} from "react";
import {NavLink} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronLeft} from "@fortawesome/free-solid-svg-icons";
import ReactGA from "react-ga4";

export default function Trophies() {
    const [trophies, setTrophies] = useState(null);
    const [processedTrophies, setProcessedTrophies] = useState(null);

    useEffect(() => {
        getTrophies(setTrophies);

        ReactGA.initialize(Config.GA_CODE);
        ReactGA.send({hitType: "pageview", page: "/trophies/", title: "Trophies"});
    }, []);  // eslint-disable-line

    useEffect(() => {
        setProcessedTrophies(trophies?.map(
            (trophy, index) => <Trophy trophy={trophy} key={index}/>
        ))
    }, [trophies]);

    return <Container>
        <Row>
        <Col xs={4}>
            <NavLink to="/extra/" className="btn btn-primary">
                <FontAwesomeIcon icon={faChevronLeft}/>
            </NavLink>
        </Col>
        </Row>
        {processedTrophies != null &&
            processedTrophies
        }
    </Container>
}

function Trophy({trophy}) {
    return <>
        <Row className="m-2" style={{textTransform: "unset", color: 'rgba(0, 0, 0, 0.8)', border: '2px gray solid', borderRadius: '15px', padding: '10px', backgroundColor: 'rgba(255,255,255,0.3)', boxShadow: '2px 2px rgba(0, 0, 0, 0.2)'}}>
            <Col xs={2}>
                <img alt={trophy.name} style={{maxWidth: "3rem"}} src={trophy.achievement_date != null ? process.env.REACT_APP_PUBLIC_URL + trophy.image : Config.lockedTrophyUrl}/>
            </Col>
            <Col xs={10}>
                <div><h6>{trophy.name}</h6></div>
                <div style={{ color: 'grey'}}>{trophy.description}</div>
            </Col>
        </Row>
    </>
}